import { Box, Tooltip } from '@lego/klik-ui';
import { StatusErrorBold, StatusInprogress, StatusSuccessBold } from '@lego/klik-ui/icons';

type Props = {
  isSuccess: boolean;
  isOutdated?: boolean;
  timestamp?: string;
  reason: string;
};

export const StatusIcon = (props: Props) => {
  if (props.isSuccess && props.isOutdated) {
    return (
      <Tooltip label={props.reason}>
        <Box textAlign="center">
          <StatusInprogress color="grey" />
        </Box>
      </Tooltip>
    );
  }

  if (props.isSuccess) {
    return (
      <Tooltip label={props.reason}>
        <Box textAlign="center">
          <StatusSuccessBold color="green" />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={props.reason}>
      <Box textAlign="center">
        <StatusErrorBold color="red" />
      </Box>
    </Tooltip>
  );
};
